import React, { useState } from 'react';
import { normalizeApiError } from './index.js';
import './errors.css';

export const ErrorAlert = React.forwardRef(function ErrorAlert({ error, failure, message, title, className = '', children, onRetry, login }, ref) {
  const normalized = failure ?? (error ? normalizeApiError(error, { fallback: message, login }) : null);
  const text = normalized?.message ?? message;
  const reference = normalized?.status >= 500 ? normalized.requestId : undefined;
  const [copied, setCopied] = useState('');
  if (!text) return null;
  return <div ref={ref} role="alert" tabIndex={-1} className={`bp-error-alert ${className}`} data-severity={[409,429].includes(normalized?.status) ? 'warning' : 'error'}>
    <div>
      {title && <strong>{title}</strong>}
      <div>{text}</div>
      {children}
    </div>
    {onRetry && <button type="button" onClick={onRetry}>Retry</button>}
    {reference && <div className="bp-error-reference">
      <span>Support reference <code>{reference}</code></span>
      <button type="button" onClick={async () => {
        try { await navigator.clipboard.writeText(reference); setCopied(reference); }
        catch { setCopied('unavailable'); }
      }}>Copy reference</button>
      <span role="status">{copied === reference ? 'Reference copied.' : copied === 'unavailable' ? 'Select the reference to copy it.' : ''}</span>
    </div>}
  </div>;
});

export function FieldError({ id, message }) {
  if (!message) return null;
  return <p id={id} className="bp-field-error">{message}</p>;
}

export function ErrorSummary({ fields, message = 'Check the highlighted fields.' }) {
  const entries = Object.entries(fields ?? {});
  if (entries.length === 0) return null;
  return <ErrorAlert message={message}><ul>{entries.map(([field, errors]) => <li key={field}>{errors.join(' ')}</li>)}</ul></ErrorAlert>;
}
